import CloseIcon from '@mui/icons-material/Close';
import { Paper, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useMedia } from 'react-use';

import { sideMenuStrings } from '../../../../constants/strings';
import { useZustand } from '../../../../zustandStore';

import RequestListMenu from './requestListMenu';

import type { FC, HTMLAttributes, PropsWithChildren } from 'react';

type SideMenuMyRequestAsideProps = HTMLAttributes<HTMLElement>;

const SideMenuMyRequestAside: FC<PropsWithChildren<SideMenuMyRequestAsideProps>> = () => {
	const isRequestAsideOpen = useZustand(state => state.aside.requestAside.isOpen);
	const { openSideMenuOnDesktopView, setIsRequestAsideOpen } = useZustand();
	const isMobileWidth = useMedia('(max-width: 650px)');

	useEffect(() => {
		if (isRequestAsideOpen && !isMobileWidth) {
			openSideMenuOnDesktopView(false);
		}
	}, [isMobileWidth, isRequestAsideOpen]);

	return (
		<Paper
			data-testid="sideMenu-drawer"
			ts-variant="sideMenuMyRequest"
			className={isRequestAsideOpen ? 'open' : 'closed'}
		>
			<Typography component="header" ts-variant="teamSwitcherHeaderTitle">
				{sideMenuStrings.SIDE_MENU_MY_REQUESTS_OPTION}
			</Typography>
			<CloseIcon
				ts-variant="teamSwitcherCloseIcon"
				onClick={() => {
					setIsRequestAsideOpen(false);
					if (!isMobileWidth) {
						openSideMenuOnDesktopView(false);
					}
				}}
			/>
			<RequestListMenu />
		</Paper>
	);
};

export default SideMenuMyRequestAside;
